module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductComments":{"empty":"Zatím nikdo nekomentoval."}},"en":{"ProductComments":{"empty":"Noone has commented yet."}}}')
  delete Component.options._Ctor
}
